import {Entity} from '../../core/commons/entity';
import {User} from 'app/core/domain/user';
import {FormView} from './form-view';
import {FormViewFieldData} from './form-view-field-data';
import {Paragraph, TextElement, ViewModelText} from "../components/view-field/view-field.component";
import {FormControl, FormGroup} from "@angular/forms";


export class FormViewData implements Entity {

    id: number;
    name = '';
    view: FormView;
    values: FormViewFieldData[] = [];
    filledBy: User;
    filledTime: number;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.values) {
            this.values = this.values.map(f => new FormViewFieldData(f));
        }
    }

    public findFieldData(fieldId: number): FormViewFieldData {
        return this.values.find(value => value.field.id === fieldId);
    }

    public removeFieldData(fieldDataId: number) {
        this.values = this.values.filter(value => value.id != fieldDataId);
    }

    public generateViewModelText(formGroup?: FormGroup): ViewModelText {
        const document = new ViewModelText();
        let p = new Paragraph(document);
        p.blockAlignment = this.values[0].field.blockAlignment;
        p.alignment = this.values[0].field.alignment;
        p.blockWidth = this.values[0].field.blockWidth;
        p.indentate = this.values[0].field.indentate;
        let shouldIndentate = false;
        for (const f of this.values) {
            const splitted = f.field.placeholder.split('<br>');
            for (let i = 0; i < splitted.length; i++) {
                splitted[i].replace('{@}', '||{@}||')
                    .split('||')
                    .forEach(s => {
                        if(s.trim().length > 0){
                            if(s === '{@}'){
                                const element = new TextElement(ViewModelText.getNewId(),'campo a completar', p, f.field.required,true);
                                element.control = formGroup.get(f.id+'') as FormControl ;
                                p.values.push(element)

                            } else {
                                p.values.push(new TextElement(ViewModelText.getNewId(), splitted[i], p, false, false))
                            }
                        }
                    });
                p.indentate = p.indentate || shouldIndentate || f.field.indentate;
                if (f.field.linebreak || i < splitted.length-1){
                    p.blockWidth = f.field.blockWidth;
                    p.blockAlignment = f.field.blockAlignment;
                    p.alignment = f.field.alignment;
                    if(p.values.length)
                        document.paragraphs.push(p);
                    p = new Paragraph(document);

                }
            }
            if((shouldIndentate || f.field.indentate) && !f.field.linebreak){
                shouldIndentate = true;
            } else {
                shouldIndentate = false;
            }
        };
        return document;
    }
}



// WEBPACK FOOTER //
// ./src/app/form-views/domain/form-view-data.ts